// extracted by mini-css-extract-plugin
module.exports = {"state":"ImportTable_state__3H9TA","name":"ImportTable_name__dJnrY","rows":"ImportTable_rows__jJ4qi","counter":"ImportTable_counter__1jhfI"};